{
  "sidebar": {
    "data": {
      "title": "Data"
    },
    "insights": {
      "title": "Insights"
    },
    "instances_caches": {
      "title": "Caches"
    },
    "dependencies": {
      "title": "Dependencies"
    },
    "jvm": {
      "title": "JVM"
    },
    "logging": {
      "title": "Logging"
    },
    "security": {
      "title": "Security"
    },
    "web": {
      "title": "Web"
    },
    "custom-link": {
      "title": "Links"
    }
  }
}
